// project import
import other, { getOtherMenu } from './other';
import pages, { getPagesMenu } from './pages';

// types
import type { User } from '@/types/auth';
import type { NavItemType } from '@/types';
import { isAdmin } from '@/utils/role';
import { ENABLED_WEEKEND_DISCHARGE_HOSPITALS } from '@/constant';
import { PERMISSIONS, STATIC_SUBSCRIBER_PERMISSIONS, hasAnyPermission, hasPermission } from '@/utils/permissions';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [pages, other]
};

type MenuItemsOptions = {
    hospitalId?: string;
    hospitalName?: string;
    user?: User | null;
    permissions?: readonly string[];
};

export const getMenuItems = ({ hospitalId, hospitalName, user, permissions = [] }: MenuItemsOptions = {}): { items: NavItemType[] } => {
    const items: NavItemType[] = [];
    const enableWeekendHandoff = ENABLED_WEEKEND_DISCHARGE_HOSPITALS.includes(String(hospitalName).trim().toLowerCase());
    const can = (key: string) => hasPermission(permissions, key);

    items.push(
        isAdmin(user)
            ? getPagesMenu({
                  hospitalId,
                  hideWeekendHandoff: !enableWeekendHandoff,
                  permissions
              })
            : getOtherMenu({
                  showHandoff: enableWeekendHandoff && can(PERMISSIONS.WEEKEND_DISCHARGE_VIEW),
                  showPatients: can(PERMISSIONS.CENSUS_VIEW),
                  showCensus: can(PERMISSIONS.CENSUS_VIEW),
                  showMeetingView: can(PERMISSIONS.MEETING_VIEW_VIEW),
                  showMeetingTranscription: can(PERMISSIONS.MEETING_TRANSCRIPTION_MANAGE),
                  showSupervisorScorecard: can(PERMISSIONS.SCORECARD_VIEW),
                  showInsights: can(PERMISSIONS.INSIGHTS_VIEW),
                  showDartReport: can(PERMISSIONS.DART_REPORT_VIEW),
                  showStaticSubscribers: hasAnyPermission(permissions, STATIC_SUBSCRIBER_PERMISSIONS),
                  showProgressNotes: can(PERMISSIONS.CCM_VIEW),
                  showManageStaff: can(PERMISSIONS.STAFF_MANAGE),
                  showAcl: can(PERMISSIONS.ACL_MANAGE)
              })
    );

    return { items };
};

/** First sidebar destination still visible for this hospital and permission set. */
export const getFirstAvailableMenuPath = (options: MenuItemsOptions = {}): string | null => {
    const { items } = getMenuItems(options);

    for (const group of items) {
        const next = group.children?.find((child) => child.url);
        if (next?.url) {
            return next.url;
        }
    }

    return null;
};

export default menuItems;
